export default __webpack_public_path__ + "static/media/calendar.d3f24a67.jpg";